import axios from 'axios'
import { Notification, MessageBox, Message } from 'element-ui'
import store from '@/store'
import errorCode from '@/utils/errorCode'
// import { getToken } from '@/utils/auth'

axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'

const request = axios.create({
    baseURL: process.env.VUE_APP_BASE_API, // 替换为你的API基地址
    // baseURL: '/dev-api',
    timeout: 1000 * 60 * 5, // 请求超时时间
});

// 请求拦截器
request.interceptors.request.use(
    config => {
        // 可以在这里添加例如token等请求头
        // if (store.getters.token) {
        //   config.headers['Authorization'] = `Bearer ${store.getters.token}`;
        // }
        config.headers['Content-Type'] = 'application/json';
        config.headers['openid'] = 'Zd$1234';
        // console.log(config)

        // if (getToken() && !isToken) {
        //     config.headers['Zeda'] = 'Bearer ' + getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
        //   }
        return config;
    },
    error => {
        // 请求错误处理
        return Promise.reject(error);
    }
);

// 响应拦截器
request.interceptors.response.use(
    res => {
        // 未设置状态码则默认成功状态
        const code = res.data.code || 200;
        // 获取错误信息
        let msg = errorCode[code] || res.data.msg || errorCode['default']
        if (code === 401) {
            MessageBox.confirm('登录状态已过期，您可以继续留在该页面，或者重新登录', '系统提示', {
                confirmButtonText: '重新登录',
                cancelButtonText: '取消',
                type: 'warning'
            }
            ).then(() => {
                store.dispatch('LogOut').then(() => {
                    location.href = '/';
                }).catch(() => {
                    location.href = '/';

                })
            })
        } else if (code === 500) {
            Message({
                message: msg,
                type: 'error'
            })
            return Promise.reject(new Error(msg))
        } else if (code !== 200) {
            Notification.error({
                title: msg
            })
            return Promise.reject('error')
        } else {
            return res.data
        }
    },
    error => {
        // 响应错误处理
        return Promise.reject(error);
    }
);

export default request;
